export const GDPR = 'gdpr';
export const NO_GDPR = 'nogdpr';
